import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import {BrowserRouter as Router, Route, Switch, Redirect, withRouter} from 'react-router-dom';
// import { IntlProvider } from 'react-intl';
// import AppLocale from './lang';
import NotificationContainer from './components/common/react-notifications/NotificationContainer';
import { isDemo } from './constants/defaultValues';
import axios from "./containers/api";
import routerService from "./constants/routerService";
import Blank from "./views/app/index";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@mui/material/Alert";
import SweetAlert from "react-bootstrap-sweetalert";
import Login from "./views/user/login";
import UserLayout from "./layout/UserLayout";
import AppLayout from "./layout/AppLayout";
import Notifications from "./views/notifications/notifications/Notifications";
import ReturnBank from "./views/user/returnbank";
import Register from "./views/user/register";
import RegisterTransportationCompany from "./views/user/RegisterTransportationCompany";
import NewRegister from "./views/user/newregister";
import RegisterProductOwner from "./views/user/RegisterProductOwner";
import RegisterDriver from "./views/user/RegisterDriver";
import NewRegisterDriver from "./views/user/newregisterdriver";
const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //loggedIn: false,
            spinner: false,
            alertOpen: false,
            alertText: "",
            alertType: "success",
            sweetAlert: false,
            sweetAlertTitle: "",
            sweetAlertText: "",
            onConfirmAlert: null,
            sweetAlertClass: "success",
            notificationsCount: 0,
            member: localStorage.getItem("member") !== "undefined" ? JSON.parse(localStorage.getItem("member")) : null,
            loggedIn: localStorage.getItem("loggedIn") !== "undefined" ? JSON.parse(localStorage.getItem("loggedIn")) : true,
            deferredPrompt: null, // ذخیره رویداد نصب
            showInstallButton: false, // نمایش دکمه نصب
        };

        if (localStorage.getItem("jwt")) {
            axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem("jwt");
        }
    }

    componentDidMount() {
        window.addEventListener('beforeunload', () => this.componentWillUnmount());
        this.activitytimer(this.state.member); 
       // if (this.state.loggedIn) {
       //     this.getUnreadNotificationsCount();
       // }
       window.addEventListener("beforeinstallprompt", (event) => {
        event.preventDefault(); // جلوگیری از نمایش پیش‌فرض
        this.setState({ deferredPrompt: event, showInstallButton: true });
      });
    }

    componentWillUnmount() {
        sessionStorage.removeItem("stimulsoftLoaded");
    }
    handleInstall = () => {
        const { deferredPrompt } = this.state;
        if (deferredPrompt) {
          deferredPrompt.prompt(); // نمایش پیام نصب
          deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === "accepted") {
              console.log("User accepted the install prompt");
            } else {
              console.log("User dismissed the install prompt");
            }
            this.setState({ deferredPrompt: null, showInstallButton: false });
          });
        }
      };
    //if logged in => add token to apis, else => go to login page
    checkJWT = () => {
        if (localStorage.getItem("jwt")) {
            axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem("jwt");
            //this.getUnreadNotificationsCount();
            // this.activitytimer();
        }
    };
    logOut = () => {
        localStorage.removeItem("jwt");
        this.setState({ loggedIn: false });
        this.props.history.push('/')
    };
    activitytimer = (member) => {
        let startTime = 0;
        let expirationtime = member !== null && member !== undefined ?((member.expirationMinutes) - 1) * 60:60; //seconds
    
         setInterval(() => {
             startTime++;
            
             if (this.state.loggedIn === true && startTime > expirationtime) {
                 this.logOut();
             }
         }, 1000);
    
       
     };
     
    getUnreadNotificationsCount = () => {
        axios.get('api/DashboardNotificationApi/GetMember48HoursAgoUnreadNotificationsCount')
            .then((res) => {
                this.setState({notificationsCount: res.data});
            })
            .catch((error) => {
                console.log(error.response);
            });
    };

    showSpinner = () => {
        this.setState({spinner: true});
    };
    hideSpinner = () => {
        this.setState({spinner: false});
    };
    showAlert = (text, type) => {
        this.setState({ alertOpen: true, alertText: text, alertType: type })
    };
    closeAlert = () => {
        this.setState({ alertOpen: false });
    };
    showSweetAlert = (title, text, alertClass, func) => {
        this.setState({ sweetAlert: true, sweetAlertTitle: title, sweetAlertText: text, onConfirmAlert: func, sweetAlertClass: alertClass });
        // if (func === "single") {
        //     this.setState({ sweetAlert: true, sweetAlertTitle: title, sweetAlertText: text, onConfirmAlert: func, sweetAlertClass: alertClass });
        // } else {
        //     this.setState({ sweetAlert: true, sweetAlertTitle: title, sweetAlertText: text, onConfirmAlert: func, sweetAlertClass: alertClass });
        // }
    };
    closeSweetAlert = () => {
        this.setState({ sweetAlert: false, sweetAlertText: "", onConfirmAlert: null, sweetAlertTitle:"" });
    };

    render() {
        const {alertText, alertOpen, alertType, sweetAlertTitle, sweetAlertText, sweetAlert, onConfirmAlert, sweetAlertClass, member} = this.state
        const location = window.location.pathname.toLowerCase();
       
        // const isLoggedIn = this.checkJWT();
        // console.log(member[routerService[3].access_code])
        // console.log(location)
        // console.log(location === "notifications")

        // if (location == '/') {
        //     console.log("ttttt")
        //     return (<Route path="/" component={Blank} />);
        // }
        // return (<Route path="/" component={Blank} />);
        // if (!this.state.loggedIn && location !== '/returnbank') {// && location.toLowerCase().includes("/returnbank")) {
        //   console.log(location);
        //     return (<Redirect to="/returnbank" push />);
        // }
    //     else
        if (!this.state.loggedIn && location !== '/login' && location !== '/returnbank' && location !== '/register' && location !== '/registertransportationcompany' && location !== '/newregister' && location !== '/registerproductowner' && location !== '/registerdriver'&& location !== '/newregisterdriver') {
           return (<Redirect to="/login" push/>);
       }

        return (
            
            <div className="h-100">
                <React.Fragment>
                    {/*<NotificationContainer/>*/}

                    {this.state.spinner ?
                        <div className="loading"/>
                        :
                        null
                    }

                    {
                        location === "/newregisterdriver" ?
                            <UserLayout>
                                <Switch>
                                    <Route
                                        exact
                                        path="/newregisterdriver"
                                        component={props => <NewRegisterDriver {...props}
                                            showSpinner={this.showSpinner}
                                            hideSpinner={this.hideSpinner}
                                            showAlert={this.showAlert}
                                            closeAlert={this.closeAlert}
                                            showSweetAlert={this.showSweetAlert}
                                            closeSweetAlert={this.closeSweetAlert}
                                        />}
                                    />
                                </Switch>
                            </UserLayout>
                            :
                        location === "/registerdriver" ?
                            <UserLayout>
                                <Switch>
                                    <Route
                                        exact
                                        path="/registerdriver"
                                        component={props => <RegisterDriver {...props}
                                            showSpinner={this.showSpinner}
                                            hideSpinner={this.hideSpinner}
                                            showAlert={this.showAlert}
                                            closeAlert={this.closeAlert}
                                            showSweetAlert={this.showSweetAlert}
                                            closeSweetAlert={this.closeSweetAlert}
                                        />}
                                    />
                                </Switch>
                            </UserLayout>
                            :
                        location === "/registerproductowner" ?
                            <UserLayout>
                                <Switch>
                                    <Route
                                        exact
                                        path="/registerproductowner"
                                        component={props => <RegisterProductOwner {...props}
                                            showSpinner={this.showSpinner}
                                            hideSpinner={this.hideSpinner}
                                            showAlert={this.showAlert}
                                            closeAlert={this.closeAlert}
                                            showSweetAlert={this.showSweetAlert}
                                            closeSweetAlert={this.closeSweetAlert}
                                        />}
                                    />
                                </Switch>
                            </UserLayout>
                            :
                            location === "/newregister" ?
                                <UserLayout>
                                    <Switch>
                                        <Route
                                            exact
                                            path="/newregister"
                                            component={props => <NewRegister {...props}
                                                showSpinner={this.showSpinner}
                                                hideSpinner={this.hideSpinner}
                                                showAlert={this.showAlert}
                                                closeAlert={this.closeAlert}
                                                showSweetAlert={this.showSweetAlert}
                                                closeSweetAlert={this.closeSweetAlert}
                                            />}
                                        />
                                    </Switch>
                                </UserLayout>
                                :

                        location === "/registertransportationcompany" ?
                        <UserLayout>
                            <Switch>
                                <Route
                                    exact
                                    path="/registertransportationcompany"
                                    component={props => <RegisterTransportationCompany {...props}
                                        showSpinner={this.showSpinner}
                                        hideSpinner={this.hideSpinner}
                                        showAlert={this.showAlert}
                                        closeAlert={this.closeAlert}
                                        showSweetAlert={this.showSweetAlert}
                                        closeSweetAlert={this.closeSweetAlert}
                                    />}
                                />
                            </Switch>
                        </UserLayout>
                        :
                    location === "/register"  ?
                        <UserLayout>
                            <Switch>
                                <Route
                                    exact
                                    path="/register"
                                    component={props => <Register {...props}
                                    showSpinner={this.showSpinner}
                                    hideSpinner={this.hideSpinner}
                                    showAlert={this.showAlert}
                                    closeAlert={this.closeAlert}
                                    showSweetAlert={this.showSweetAlert}
                                    closeSweetAlert={this.closeSweetAlert}  
                                    />}
                                />
                            </Switch>
                        </UserLayout>
                    :
                    location === "/returnbank"  ?
                        <UserLayout>
                            <Switch>
                                <Route
                                    exact
                                    path="/returnbank"
                                    component={props => <ReturnBank {...props} />}
                                />
                            </Switch>
                        </UserLayout>
                    :
                    location === "/login" ?
                    <UserLayout>
                        <Switch>
                            <Route
                                exact
                                path="/login"
                                        component={props => <Login {...props}
                                            showSpinner={this.showSpinner}
                                            hideSpinner={this.hideSpinner}
                                            showAlert={this.showAlert}
                                            closeAlert={this.closeAlert}
                                            showSweetAlert={this.showSweetAlert}
                                            closeSweetAlert={this.closeSweetAlert}                                        />}
                            />
                        </Switch>
                    </UserLayout>
                    :
                        <AppLayout notificationsCount={this.state.notificationsCount}>
                            <div className="dashboard-wrapper">
                                <Suspense fallback={<div className="loading"/>}>
                                    <Switch>
                                        {routerService && routerService.map((route, key) => {
                                            if (route.path === "Notifications") {
                                                return (
                                                    <Route exact
                                                           path="/Notifications"
                                                           render={props =>
                                                               <Notifications {...props}
                                                                              showSpinner={this.showSpinner}
                                                                              hideSpinner={this.hideSpinner}
                                                                              showAlert={this.showAlert}
                                                                              closeAlert={this.closeAlert}
                                                                              showSweetAlert={this.showSweetAlert}
                                                                              closeSweetAlert={this.closeSweetAlert}
                                                                              getUnreadNotificationsCount={this.getUnreadNotificationsCount}
                                                               />}
                                                    />
                                                )
                                            } else if (route.roles === "all" || route.roles.includes(member.role) || member[route.access_code]) {
                                                return (
                                                    <Route key={key} exact path={`/${route.path}`}
                                                           render={props =>
                                                               <route.component {...props}
                                                                                showSpinner={this.showSpinner}
                                                                                hideSpinner={this.hideSpinner}
                                                                                showAlert={this.showAlert}
                                                                                closeAlert={this.closeAlert}
                                                                                showSweetAlert={this.showSweetAlert}
                                                                                closeSweetAlert={this.closeSweetAlert}
                                                                   memberType={this.state.member}
                                                               />
                                                           }
                                                    />
                                                )
                                            }
                                        })}
                                    </Switch>
                                </Suspense>
                            </div>
                        </AppLayout>
                    }



                    {/*<>*/}


                    {/*    {routerService && routerService.map((route, key) =>*/}
                    {/*        <Route key={key} path={`/${route.path}`}*/}
                    {/*               render={props =>*/}
                    {/*                   <route.component {...props}*/}
                    {/*                                    showSpinner={this.showSpinner}*/}
                    {/*                                    hideSpinner={this.hideSpinner}*/}
                    {/*                                    showAlert={this.showAlert}*/}
                    {/*                                    closeAlert={this.closeAlert}*/}
                    {/*                                    showSweetAlert={this.showSweetAlert}*/}
                    {/*                                    closeSweetAlert={this.closeSweetAlert}*/}
                    {/*                   />*/}
                    {/*        } />*/}
                    {/*    )}*/}
                    {/*</>*/}

                    {/*{location === "/" ?*/}
                    {/*    <Route path={`/`}*/}
                    {/*           render={props =>*/}
                    {/*               <Blank {...props}*/}
                    {/*                      showSpinner={this.showSpinner}*/}
                    {/*                      hideSpinner={this.hideSpinner}*/}
                    {/*                      showAlert={this.showAlert}*/}
                    {/*                      closeAlert={this.closeAlert}*/}
                    {/*                      showSweetAlert={this.showSweetAlert}*/}
                    {/*                      closeSweetAlert={this.closeSweetAlert}*/}
                    {/*               />*/}
                    {/*           }*/}
                    {/*    />*/}
                    {/*    :*/}
                    {/*    null*/}
                    {/*}*/}

                    {/*<Route path="/" render={props => <Blank {...props}*/}
                    {/*                                        showSpinner={this.showSpinner}*/}
                    {/*                                        hideSpinner={this.hideSpinner} /> } />*/}

                    {/*{location == "/" ?*/}
                    {/*    <Route path="/" render={props => <routerService. {...props}*/}
                    {/*                                            showSpinner={this.showSpinner}*/}
                    {/*                                            hideSpinner={this.hideSpinner} /> } />*/}
                    {/*    :*/}
                    {/*    <>*/}
                    {/*        {routerService && routerService.map((route, key) =>*/}
                    {/*            <Route key={key} path={`/${route.path}`} component={route.component} />*/}
                    {/*        )}*/}
                    {/*    </>*/}
                    {/*}*/}


                    {/*<Router>*/}
                    {/*    <Switch>*/}
                    {/*        */}
                    {/*        /!*<Redirect to="/error" push/>*!/*/}
                    {/*    </Switch>*/}
                    {/*</Router>*/}
                </React.Fragment>

                <Snackbar
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    open={alertOpen}
                    autoHideDuration={5000}
                    onClose={this.closeAlert}
                    ContentProps={{'aria-describedby': 'message-id'}}
                >
                    <Alert onClose={this.closeAlert} severity={alertType}>
                        {alertText}
                    </Alert>
                </Snackbar>

                <SweetAlert
                    focusConfirmBtn={false}
                    success={sweetAlertClass === "success"}
                    danger={sweetAlertClass === "danger"}
                    warning={sweetAlertClass === "warning"}
                    confirmBtnText="بله"
                    confirmBtnBsStyle="outline-success"
                    cancelBtnText="خیر"
                    cancelBtnBsStyle='outline-danger'
                    showCancel={true}
                    reverseButtons={true}
                    btnSize="sm"
                    show={sweetAlert}
                    title={sweetAlertTitle}
                    showConfirm={onConfirmAlert !== "single"}
                    onConfirm={onConfirmAlert}
                    onClickOutside={this.closeSweetAlert}
                    onCancel={this.closeSweetAlert}
                >
                    {sweetAlertText}
                </SweetAlert>
                <div style={{ textAlign: "center", marginTop: "50px" }}>
                 <h1></h1>
                    {this.state.showInstallButton && (
                        <button onClick={this.handleInstall} style={styles.button}>
                          نصب اپلیکیشن        
                        </button>
                    )}
                </div>
            </div>

        );
    }
    
}
const styles = {
    button: {
      padding: "10px 20px",
      fontSize: "16px",
      backgroundColor: "#007bff",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      marginTop: "20px",
    },
  };
const mapStateToProps = ({ authUser }) => {
  const { user: loginUser } = authUser;
  return { loginUser };
};
const mapActionsToProps = {};

export default connect(
    mapStateToProps,
    mapActionsToProps
)(App);
